import { array, object, string } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { language } from 'components/Wizards/schemas/shared/language'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { meta } from '../schemaCommon'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'

export const FlowM3Schema = ({ generationType }: { generationType: GenerationType }) => {
  const ShareDetailsSchema = object({
    topic: string()
      .required('Please describe what the content involves')
      .meta({
        label: 'What is the content brief about?',
        type: 'textarea',
        autoFill: true,
        generationType,
        rows: 4,
      })
      .transform(safify),

    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType, autoFill: false }),
  }).meta({
    title: 'Share some details',
  }) as StepSchema

  const RefinementSchema = object({
    outline_structure: string()
      .oneOf([
        'Traditional',
        'Problem-solution',
        'How-to',
        'Storytelling',
        'Interview',
        'Video/podcast script',
        'Discussion',
      ])
      .default('Traditional')
      .meta({
        label: 'What structure should the outline follow?',
        oneOfPills: true,
      })
      .transform(safify),
    filename,
    project,
    language: language.meta({ overflow: true, autoFill: true }),
    include_emojis: includeEmojis.meta({ overflow: true, autoFill: true }),
    tone: tone.optional().meta({
      generationType,
      overflow: true,
      label: 'More ways to configure',
    }),
  }).meta({
    title: 'Refine the details',
    submitLabel: 'Continue',
  }) as StepSchema

  const MediaSchema = object({
    selected_images: array()
      .of(string())
      .default([])
      .meta({
        skipBackgroundRemoval: true,
        multiSelect: true,
      })
      .transform(safify),
    featured_selected_images: array()
      .of(string())
      .default([])
      .meta({
        skipBackgroundRemoval: true,
        multiSelect: true,
      })
      .transform(safify),
  }).meta({
    title: 'Pick your images',
    submitLabel: 'Generate Content Brief',
    fullWidth: true,
  }) as StepSchema

  return {
    meta,
    steps: [ShareDetailsSchema, RefinementSchema, MediaSchema],
  } as MultiStepSchema<GenerationType>
}
